(() => {
  'use strict';

  if (window.__SOLI_CURRENCY_LOCALIZER__) return;
  window.__SOLI_CURRENCY_LOCALIZER__ = true;

  const amount = '([0-9]+(?:[,.\\u00a0\\u202f ]?[0-9]{3})*(?:[,.][0-9]{1,2})?)';
  const prefixedCurrency = new RegExp('(?:DZD|DA|دج)\\s*' + amount, 'g');
  const suffixedCurrency = new RegExp(amount + '\\s*(?:DZD|DA|دج)', 'g');
  const currencyPattern = /\b(?:DZD|DA)\b|دج/g;
  const currencyForLocale = () => document.documentElement.lang.toLowerCase().startsWith('ar') ? 'دج' : 'DA';

  const formatPrice = (value) => {
    const currency = currencyForLocale();
    return value
      .replace(prefixedCurrency, (_match, price) => `${price.trim()} ${currency}`)
      .replace(suffixedCurrency, (_match, price) => `${price.trim()} ${currency}`)
      .replace(currencyPattern, currency);
  };

  const replaceTextNode = (node) => {
    if (node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    const parent = node.parentElement;
    if (parent && parent.closest('script, style, noscript, textarea')) return;
    node.nodeValue = formatPrice(node.nodeValue);
  };

  const replaceCurrency = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTextNode(root);
      return;
    }
    if (!(root instanceof Element) && root !== document.body) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      replaceTextNode(node);
      node = walker.nextNode();
    }
  };

  const start = () => {
    replaceCurrency(document.body);
    new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach(replaceCurrency)))
      .observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
